/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return this.args.type != null;
  }


  isPaneCollapsed ()
  {
    return this.args.type != null;
  }


  getSelectShape (source, galaxy)
  {
    return galaxy.getConstants().getUnit(this.args.type).getTargetShape()()
  }


};

